import React, { useEffect, useRef } from 'react';

const CredlyBadge = ({ badgeId }) => {
  const badgeContainerRef = useRef(null);

  useEffect(() => {
    if (badgeContainerRef.current) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = '//cdn.credly.com/assets/utilities/embed.js';

      const div = document.createElement('div');
      div.setAttribute('data-iframe-width', '150'); // Adjust as needed
      div.setAttribute('data-iframe-height', '270'); // Adjust as needed
      div.setAttribute('data-share-badge-id', badgeId);
      div.setAttribute('data-share-badge-host', 'https://www.credly.com');

      // Clear any existing content before appending
      badgeContainerRef.current.innerHTML = '';
      badgeContainerRef.current.appendChild(div);
      badgeContainerRef.current.appendChild(script);
    }
  }, [badgeId]);

  return <div ref={badgeContainerRef}></div>;
};

export default CredlyBadge;